import React from "react";
import { useNavigate } from 'react-router-dom';
import { Button } from "components/ui";
import { getUserPurchasePlanLimitStates } from "api/endpoints/getUserPurchasePlanLimitStates";
import { GeneralErrorMessageModal } from "components/GeneralErrorMessageModal/GeneralErrorMessageModal";
import navigationPaths from "engine/navigationPaths";

export const AddDocumentButton = ({children, onClick, ...rest}) => {
    const navigate = useNavigate();
    const [errorDialogOpen, setErrorDialogOpen] = React.useState(false);

    const onPreClick = () => {
        getUserPurchasePlanLimitStates().then((data) => {
            if(data.documentLimitExceeded) {
                setErrorDialogOpen(true);
            } else {
                onClick();
            }
        });
    };
    
    const handleErrorDialogConfirm = () => {
        setErrorDialogOpen(false);
        navigate(navigationPaths().Pricing);
    };

    const handleErrorDialogClose = () => {
        setErrorDialogOpen(false);
    };

    return (
        <React.Fragment>
            {errorDialogOpen && <GeneralErrorMessageModal
                id="error-message"
                onClose={handleErrorDialogClose}
                onConfirm={handleErrorDialogConfirm}
                title="Limit wyczerpany" closeText="Przejdź do Planów cenowych"
                message="Przekroczony został dostępny limit tworzonych dokumentów."
            />}        
            <Button onClick={() => onPreClick()} {...rest}>
                {children}
            </Button>
      </React.Fragment>
    )
};